import { render } from "./LocationsMap.vue?vue&type=template&id=42d74b7a"
import script from "./LocationsMap.vue?vue&type=script&lang=js"
export * from "./LocationsMap.vue?vue&type=script&lang=js"

import exportComponent from "/Users/martin/www/forton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__